/**
 * The activity ticket: a small betting-slip of paper under the cash and heat plates while a race or a
 * minicab shift runs ("2ND OF 3 · Gate 4 of 9 · 1:02.4", "FARE 2 OF 4 · Meter £48 · Care ★★·").
 * Presentation only; built once, updated by text writes.
 */
import './activities.css';
import { el, setText, toggle } from '../ui/dom';
import type { TicketInfo } from './host';

export class ActivityTicket {
  readonly root: HTMLElement;
  private readonly head: HTMLElement;
  private readonly lines: HTMLElement[] = [];
  private shown: TicketInfo | null = null;
  private lastHead = '';

  constructor(parent: HTMLElement) {
    this.root = el('div', 'act-ticket bh-glass', undefined, parent);
    this.root.hidden = true;
    this.root.setAttribute('aria-live', 'polite');
    this.head = el('div', 'act-head', undefined, this.root);
    for (let i = 0; i < 3; i++) this.lines.push(el('div', 'act-line', undefined, this.root));
  }

  set(t: TicketInfo | null): void {
    this.shown = t;
    if (!t) {
      this.root.hidden = true;
      this.lastHead = '';
      return;
    }
    this.root.hidden = false;
    setText(this.head, t.head);
    this.lines.forEach((e, i) => {
      const text = t.lines[i] ?? '';
      setText(e, text);
      e.hidden = !text;
    });
    // A new place or a countdown beat: a quick stamp.
    if (t.head !== this.lastHead) {
      if (this.lastHead && (t.flash || /OF \d/.test(t.head))) {
        this.root.classList.remove('beat');
        void this.root.offsetWidth;
        this.root.classList.add('beat');
      }
      this.lastHead = t.head;
    }
    toggle(this.root, 'count', !!t.flash);
  }

  get state(): TicketInfo | null {
    return this.shown;
  }

  dispose(): void {
    this.root.remove();
  }
}
